module.exports = __webpack_public_path__ + "static/media/Eating Disorders.f65e9c42.svg";